import React from 'react';
import Icon from '../../../components/AppIcon';
import { isPatientMarkedInactiveStatus } from '../../../lib/patientStatus';

const PatientInfoCard = ({ patient, onEdit, avatarUrl }) => {

  
  if (!patient) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <div className="flex items-center justify-center h-32 text-muted-foreground">
          <p className="text-sm">Aucune donnée patient disponible</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-start justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Informations du Patient</h2>
        <button
          onClick={onEdit}
          className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
          aria-label="Modifier les informations du patient"
        >
          <Icon name="Edit" size={20} className="text-muted-foreground" />
        </button>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Avatar Section */}
        <div className="flex-shrink-0">
          <div className="w-32 h-32 rounded-lg overflow-hidden bg-muted flex items-center justify-center">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt=""
                className="w-full h-full object-cover"
              />
            ) : patient.initials ? (
              <span className="text-4xl font-semibold text-muted-foreground">
                {patient.initials}
              </span>
            ) : (
              <Icon name="User" size={48} className="text-muted-foreground" />
            )}
          </div>
        </div>

        {/* Patient Info Grid */}
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Patient Code */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Code Patient</p>
            <p className="text-sm font-medium text-foreground">
              {patient.patientCode || 'N/A'}
            </p>
          </div>

          {/* Full Name */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Nom Complet</p>
            <p className="text-sm font-medium text-foreground">
              {patient.fullName || 'Non renseigné'}
            </p>
          </div>

          {/* Date of Birth */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Date de Naissance</p>
            <p className="text-sm font-medium text-foreground">
              {patient.dateOfBirth || 'Non renseigné'}
            </p>
          </div>

          <div>
            <p className="text-xs text-muted-foreground mb-1">Sexe</p>
            <p className="text-sm font-medium text-foreground">
              {patient.genderLabel || 'Non renseigné'}
            </p>
          </div>

          {/* Email */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Email</p>
            <p className="text-sm font-medium text-foreground break-all">
              {patient.email || 'Non renseigné'}
            </p>
          </div>

          {/* Phone */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Téléphone</p>
            <p className="text-sm font-medium text-foreground">
              {patient.phone || 'Non renseigné'}
            </p>
          </div>

          {/* Address (Location) */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Localisation</p>
            <p className="text-sm font-medium text-foreground">
              {patient.address || 'Non renseignée'}
            </p>
          </div>

          {/* Registration Date */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Date d'Inscription</p>
            <p className="text-sm font-medium text-foreground">
              {patient.registrationDate || 'Non renseigné'}
            </p>
          </div>

          {/* Last Visit */}
         

          {/* Active Cases */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Cas Actifs</p>
            <p className="text-sm font-medium text-foreground">
              {patient.activeCases !== undefined ? patient.activeCases : 'N/A'}
            </p>
          </div>

          {/* Status */}
          <div>
            <p className="text-xs text-muted-foreground mb-1">Statut</p>
            <span
              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                isPatientMarkedInactiveStatus(patient.statusRaw)
                  ? 'bg-muted text-muted-foreground'
                  : 'bg-success/10 text-success'
              }`}
            >
              {patient.statusLabel || 'Non défini'}
            </span>
          </div>
        </div>
      </div>

      {/* Notes Section (if notes field is added to database later) */}
      {patient.notes && (
        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-xs text-muted-foreground mb-2">Notes Cliniques</p>
          <p className="text-sm text-foreground">{patient.notes}</p>
        </div>
      )}
    </div>
  );
};

export default PatientInfoCard;